export default __webpack_public_path__ + "static/media/quero500.c76d97fe.png";